import { render, staticRenderFns } from "./AppUpdateBar.vue?vue&type=template&id=273338ee&"
import script from "./AppUpdateBar.vue?vue&type=script&lang=js&"
export * from "./AppUpdateBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports